import { Builder } from '@builder.io/react';
import { WaxingCostPerYear } from '../../shared';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';

Builder.registerComponent(WaxingCostPerYear, {
    name: BUILDER_DIVIDER_NAMES.WaxingCostPerYear,
});
